export function filterRecipients(recipients, searchQuery, getSearchText) {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return [...recipients];
    return recipients.filter(recipient => getSearchText(recipient).includes(query));
}

export function toggleSelection(selectedIds, id) {
    const next = new Set(selectedIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
}

export function selectVisible(selectedIds, visibleRecipients) {
    const next = new Set(selectedIds);
    for (const recipient of visibleRecipients) next.add(recipient.id);
    return next;
}

export function selectedRecipients(recipients, selectedIds) {
    return recipients.filter(recipient => selectedIds.has(recipient.id));
}
